<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title>{{TitleText}}</h1>
  <div fxFlex class="scroll">
    <p [innerHTML]="MessageText | safeHTML"></p>
    <mat-table class="bordered" #table [dataSource]="DetailsData" matSort matSortActive="StudentName" matSortDirection="asc">
      <!-- Student Name Column -->
      <ng-container matColumnDef="StudentName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Student Name</mat-header-cell>
        <mat-cell *matCellDef="let item" class="centered">{{item.StudentName}}</mat-cell>
      </ng-container>

      <!-- Student ID Column -->
      <ng-container matColumnDef="StudentID">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Student ID</mat-header-cell>
        <mat-cell *matCellDef="let item" class="centered">{{item.StudentID}}</mat-cell>
      </ng-container>

      <!-- College Column -->
      <ng-container matColumnDef="College">
        <mat-header-cell *matHeaderCellDef class="centered">College</mat-header-cell>
        <mat-cell *matCellDef="let item" class="centered">{{item.CollegeName}}</mat-cell>
      </ng-container>

      <!-- College Term Column -->
      <ng-container matColumnDef="CollegeTerm">
        <mat-header-cell *matHeaderCellDef class="centered">Term</mat-header-cell>
        <mat-cell *matCellDef="let item" class="centered"><div>{{item.Term | collegeTerm}}</div>
            <div>{{item.SchoolYear | schoolYear}}</div></mat-cell>
      </ng-container>

        <!-- School Column -->
        <ng-container matColumnDef="SchoolName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">School</mat-header-cell>
            <mat-cell *matCellDef="let item" class="centered">{{item.SchoolName}}</mat-cell>
        </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="FormStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Current Status</mat-header-cell>      
          <mat-cell *matCellDef="let item" class="centered">{{item.FormStatus | formStatus}}</mat-cell>
      </ng-container>

      <!-- Date Updated Column -->
      <ng-container matColumnDef="DateUpdated">
        <mat-header-cell *matHeaderCellDef class="centered">Date Updated</mat-header-cell>
        <mat-cell *matCellDef="let item" class="centered">{{item.DateUpdated | date:'M/d/yyyy'}}</mat-cell>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="Actions">
        <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
        <mat-cell *matCellDef="let item" class="centered">
          <button mat-raised-button color="primary" (click)="ViewCollege(item)">View</button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="SmallDisplay">
        <mat-header-cell *matHeaderCellDef class="centered">Notification(s)</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>Student Name</form-label>
              <div>{{item.StudentName}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>Student ID</form-label>
              <div>{{item.StudentID}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>College</form-label>
              <div>{{item.CollegeName}}</div>
            </div>
            <div *ngIf="IsAdvisor" fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>Schoo0l</form-label>
              <div>{{item.CollegeName}}</div>
            </div>
            <div *ngIf="IsAdvisor" fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>Current Status</form-label>
              <div>{{item.FormStatus | formStatus}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>Term</form-label>
              <div fxLayout="column" fxLayoutAlign="start end">
                    <div>{{item.Term | collegeTerm}}</div>
                    <div>{{item.SchoolYear | schoolYear}}</div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <form-label>Date Updated</form-label>
              <div>{{item.DateUpdated | date:'M/d/yyyy'}}</div>
            </div>
            <div class="actionbar" fxLayout="column" fxLayoutAlign="start center">
              <button mat-raised-button color="primary" (click)="ViewCollege(item)">View</button>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Table contents -->
      <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
      <mat-row *matRowDef="let row; columns:VisibleColumns"></mat-row>
    </mat-table>
  </div>
  <div class="bottomactionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayoutAlign.lt-md="center center">
    <button mat-raised-button color="primary" (click)="OKHandler()">OK</button>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/classicnotification/classicnotification.dialogcomponent.html